<template>
  <div>
    <iframe
      allowfullscreen="allowfullscreen"
      scrolling="no"
      class="fp-iframe"
      src="https://heyzine.com/flip-book/de580e1f39.html"
      style="border: 1px solid lightgray; width: 100dvw; height: 100dvh"
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
